import { createContext, Dispatch, SetStateAction } from "react";
import { defaultTemplate, Template } from "../sdkStructs";

export interface TemplateStates {
  template: Template | null,
  setTemplate: Dispatch<SetStateAction<Template | null>>,

  forceRegenerate: () => void;
}

export const TemplateContext = createContext<TemplateStates>({
  template: defaultTemplate,
  setTemplate: () => {},
  forceRegenerate: () => {},
});
